// extracted by mini-css-extract-plugin
export var centerList = "_gp-6";
export var centerLoc = "_gp-a";
export var centerName = "_gp-9";
export var centerOptionBody = "_gp-8";
export var centerRow = "_gp-7";
export var centerStatus = "_gp-b";
export var empty = "_gp-5";
export var externalIcon = "_gp-c";
export var fieldHeader = "_gp-2";
export var fieldHelp = "_gp-4";
export var fieldLabel = "_gp-3";
export var panel = "_gp-0";
export var removeBtn = "_gp-d";
export var section = "_gp-1";